import React, { Component } from "react";
import { Link } from "react-router-dom";
import { DropdownButton, MenuItem } from "react-bootstrap";
import "./index.css";
import icon from "../../../assets/images/extend_nav/Whitearrowdown.svg"
export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    let data = {
      dates: this.props.data.options ? this.props.data.options : [],
      ...props.data
    };
    this.state = {
      data: data,
      dropDownTitle: this.props.data.current
        ? this.props.data.current
        : this.props.data.options.name
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(eventKey) {
    window.location.replace(
      this.state.data.dates[eventKey].link &&
        this.state.data.dates[eventKey].link
        ? this.state.data.dates[eventKey].link
        : this.state.data.dates[eventKey].url
    );
  }

  render() {
    // console.log("border", this.props.border);
    // console.log("giveMeClassName", this.props.giveMeClassName);
    return (
      <div>
        {this.props.giveMeClassName === "festiwal--dropdown" ? (
          <DropdownButton
            className={this.props.border ? "standard festiwal--dropdown" : "festiwal--dropdown dropd"}
            bsSize="small"
            title={
              this.state.data.current
                ? <span style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width:'100%',
                  alignItems:'center',
                }}
                className="dropdown--icon"> {this.state.data.current}<img style={{
                  maxWidth:'100%',
                  width:'22px',
                  height:'26px'
                }} src={icon}/></span>
                : <span style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width:'100%',
                  alignItems:'center',
                }} className="dropdown--icon">{this.state.data.title}<img style={{
                  maxWidth:'100%',
                  width:'22px',
                  height:'26px'
                }}src={icon}/></span>
            }
            id="dropdown-size-large"
          >
            {this.state.data.dates.map((item, index) => {
              // console.log(item);
              return (
                <MenuItem eventKey={index} key={index} onSelect={this.handleChange}>
                  {item.text && item.text ? item.text : null}
                  {item.name && item.name ? item.name : null}
                </MenuItem>
              );
            })}
          </DropdownButton>
        ) : (
          <DropdownButton
            className={this.props.border ? "standard" : "dropd"}
            bsSize="small"
            title={
              this.state.data.current
                ? this.state.data.current
                : this.state.data.title
            }
            id="dropdown-size-large"
          >
            {this.state.data.dates.map((item, index) => {
              // console.log(item);
              return (
                <MenuItem eventKey={index} onSelect={this.handleChange}>
                  {item.text && item.text ? item.text : null}
                  {item.name && item.name ? item.name : null}
                </MenuItem>
              );
            })}
          </DropdownButton>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/Dropdown/index.js